import React from 'react';
import cn from 'classnames';
import { Select } from '@dealroadshow/uikit-select';
import {
  SelectOptionWithCountryFlag,
  SelectSingleValueWithCountryFlag,
} from '@dealroadshow/uikit-select/components';
import useI18nInstance from '../hooks/useI18nInstance';
import styles from './languageSwitcher.module.scss';

export interface ILanguageOption {
  label: string,
  value: string,
  countryCode: string,
}

interface IProps {
  options: ILanguageOption[],
  className?: string,
  onChange?: (option: ILanguageOption) => void,
}

const LanguageSwitcher = ({ className, options, onChange }: IProps) => {
  const i18nInstance = useI18nInstance();
  const selectedOption = options.find((option) => option.value === i18nInstance.language);

  const onChangeHandler = async (option: ILanguageOption) => {
    await i18nInstance.changeLanguage(option.value);
    onChange?.(option);
  };

  return (
    <Select<ILanguageOption>
      options={ options }
      className={ cn(styles.switcher, className) }
      classNames={ {
        container: () => styles.switcherContainer,
        control: () => styles.switcherControl,
        singleValue: () => styles.switcherSingleValue,
        valueContainer: () => styles.switcherValueContainer,
        menu: () => styles.switcherMenu,
        menuList: () => styles.switcherMenuList,
        option: () => styles.switcherOption,
      } }
      classNamePrefix="languageSwitcher"
      components={ {
        Option: SelectOptionWithCountryFlag,
        SingleValue: SelectSingleValueWithCountryFlag,
      } }
      // @ts-ignore
      value={ selectedOption }
      // @ts-ignore // TODO: fix strictFunctionTypes types
      onChange={ onChangeHandler }
      backspaceRemovesValue={ false }
      // @ts-ignore
      isSearchable={ false }
      isClearable={ false }
      dataTest="languageSwitcher"
    />
  );
};

export default LanguageSwitcher;
